import { DOCUMENT_STATUS } from '@tencent/ark-model';
import { IClientVars } from '../interfaces/client-vars.interface';

export function createEmptyClientVars(): IClientVars {
    return {
        collab_client_vars: {
            bad: -1,
            client: {
                sid: '',
                upid: '',
                sig: '',
                tid: -1,
            },
            dirty: -1,
            globalPadId: '',
            gray: -1,
            initialAttributedText: { text: '' },
            padId: '',
            padSubId: 'BB08J2',
            padType: '',
            pos: -1,
            pver: -1,
            rev: 0,
            ver: -1,
            websocket: true,
            wmode: '',
        },
        creatorDomain: '',
        creatorId: '',
        docStatus: -1,
        domainId: '',
        globalPadId: '',
        isCreator: true,
        isLogin: true,
        isOverConNum: false,
        isOwner: false,
        isUserChangeTitle: false,
        localPadId: '',
        ownerId: '',
        padId: '',
        padStatus: DOCUMENT_STATUS.new,
        padTitle: '',
        padType: '',
        policy: -1,
        privilegeAttribute: {
            is_auth: true,
            can_copy: true,
            can_print: true,
            can_history: true,
            can_read: true,
            can_edit_title: true,
            can_search: true,
            can_add_user: true,
            can_view_image: true,
            can_edit: true,
            can_share: true,
            can_comment: true,
            can_about: true,
            can_spit_slot: true,
            can_watermark: true,
            can_translate: true,
            can_link_exp: true,
            can_copy_doc: true,
            can_publish: true,
            can_set_range: true,
            can_edit_tab: true,
            can_export: true,
            can_apply_edit: true,
            can_save_template: true,
            can_edit_collab: true,
            can_view_collab: true,
            can_invite_member: true,
            is_admin: true,
            can_view_priv_setting: true,
            can_edit_priv_setting: true,
            can_set_internal_access: true,
            can_set_external_access: true,
            can_set_security_setting: true,
            can_invite_special_depts: true,
            can_search_user: true,
            can_filter_user: true,
            can_forbid_viewer_comment: true,
            can_forbid_viewer_copy_doc: true,
            can_transfer: true,
            can_annotate: true,
            can_set_enter_rule: true,
            can_delete: true,
            can_create_file: true,
            can_create_folder: true,
            can_fill: true,
            can_view_browsing_history: true,
            can_copy_out: true,
            can_collect: true,
            can_high_light_title: true,
            can_invisible_visit: true,
            can_cache: true,
            can_export_online: true,
            can_add_revision: true,
        },
        privilegeExpire: -1,
        rightFlag: -1,
        title: '',
        userId: '',
        metaCreateTime: Date.now(),
        lastModifyTime: Date.now(),
        lastModifyUser: '',
        advPolicy: {},
    };
}

export function createLogoutPrivilegeAttribute() {
    return {
        can_about: true,
        can_add_user: false,
        can_comment: true,
        can_copy: true,
        can_edit: false,
        can_edit_title: false,
        can_history: false,
        can_link_exp: false,
        can_print: true,
        can_read: true,
        can_search: true,
        can_share: true,
        can_spit_slot: true,
        can_translate: true,
        can_view_image: true,
        can_watermark: false,
        is_auth: false,
    };
}
